// import axios from "axios";
import apiMixin from "../../../mixins/apiMixin";


const BrandKonstruktorKonstruct = {
    namespaced: true,
    state: {
        islikeResult: [],
        islikeResultExtra: [],

        urbanizeResult: [],
        urbanizeResultExtra: [],

        soundlikeResult: [],
        soundlikeResultExtra: [],

        describelikeResult: [],
        describelikeResultExtra: [],

        foreignizeResult: [],
        foreignizeResultExtra: [],

        abbreviateResult: [],
        abbreviateResultExtra: [],

        randomgeneratorResult: [],
        randomgeneratorResultExtra: [],
    },
    mutations: {
        setislikeResult: function (state, payload) {
            state.islikeResult = payload;
        },
        seturbanizeResult: function (state, payload) {
            state.urbanizeResult = payload;
        },
        setsoundlikeResult: function (state, payload) {
            state.soundlikeResult = payload;
        },
        setdescribelikeResult: function (state, payload) {
            state.describelikeResult = payload;
        },
        setforeignizeResult: function (state, payload) {
            state.foreignizeResult = payload;
        },
        setabbreviateResult: function (state, payload) {
            state.abbreviateResult = payload;
        },
        setrandomgeneratorResult: function (state, payload) {
            state.randomgeneratorResult = payload;
        }
    },
    actions: {
        submitSearch: async function (state, payload) {
            console.log(payload.job_type)
            return apiMixin.methods.konsruktorSearch(payload).then(

                response => {
                    console.log(response)
                    if (!response) {

                        return false;
                    }
                    localStorage.setItem('khonsu_search_token',JSON.stringify(response.data))
                    return true;

                });
        },
        resultislike: async function (state, payload) {

            return apiMixin.methods.islikeResult(payload).then(
                response => {
                    if (!response) {
                        return false;
                    }
                    if (typeof response.data !== 'undefined') {

                        state.commit('setislikeResult', response.data);
                    }
                    return true;

                });
        },
        resultUrbanize: async function (state, payload) {
            return apiMixin.methods.urbanizeResult(payload).then(
                response => {
                    if (!response) {
                        return false;
                    }
                    if (typeof response.data !== 'undefined') {
                        if (response.data.StringValue!=null){
                            state.commit('seturbanizeResult', response.data.StringValue.split(','));
                        }

                    }
                    return true;

                });
        },
        resultForeignize: async function (state, payload) {
            return apiMixin.methods.foreignizeResult(payload).then(
                response => {
                    if (!response) {
                        return false;
                    }
                    if (typeof response.data !== 'undefined') {
                        state.commit('setforeignizeResult', response.data);
                    }
                    return true;

                });
        },
        resultAbbrevaite: async function (state, payload) {
            return apiMixin.methods.abbrviateResult(payload).then(
                response => {
                    if (!response) {
                        return false;
                    }
                    if (typeof response.data !== 'undefined') {
                        state.commit('setabbreviateResult', response.data);
                    }
                    return true;

                });
        },
        resultrandomgenerator: async function (state, payload) {
            return apiMixin.methods.randomgeneratorResult(payload).then(
                response => {
                    if (!response) {
                        return false;
                    }
                    if (typeof response.data !== 'undefined') {
                        state.commit('setrandomgeneratorResult', response.data);
                    }
                    return true;

                });
        },
        resultSoundlike: async function (state, payload) {
            return apiMixin.methods.soundlikeResult(payload).then(
                response => {
                    if (!response) {
                        return false;
                    }
                    if (typeof response.data !== 'undefined') {
                        state.commit('setsoundlikeResult', response.data);
                    }
                    return true;

                });
        },
        resultDescribelike: async function (state, payload) {
            return apiMixin.methods.describelikeResult(payload).then(
                response => {
                    if (!response) {
                        return false;
                    }
                    if (typeof response.data !== 'undefined') {
                        state.commit('setdescribelikeResult', response.data);
                    }
                    return true;

                });
        },
    },
    getters: {},
}
export default BrandKonstruktorKonstruct